import styles from './GeneralDetails.module.scss';

const GeneralDetails = (props) => {
	const { fields } = props;
	return (
		<div className={`${styles.root} row`}>
			<div
				style={{
					flexBasis: '50%',
				}}
			>
				{/* product name */}
				<div className='form-field row'>
					<div className='form-label'>Product Name</div>
					<div className='form-value'>{fields.name}</div>
				</div>
				{/* brand name */}
				<div className='form-field row'>
					<div className='form-label'>Brand Name</div>
					<div className='form-value'>{fields.brand}</div>
				</div>
				<div className='form-field row'>
					<div className='form-label'>Inventory Unit</div>
					<div className='form-value'>{fields.unit}</div>
				</div>
				<div className='form-field row'>
					<div className='form-label'>Purchase Unit</div>
					<div className='form-value'>{fields.purchaseUnit}</div>
				</div>
				<div className='form-field row'>
					<div className='form-label'>SKU Type</div>
					<div className='form-value'>{fields.skuType}</div>
				</div>
			</div>
			<div
				style={{
					marginLeft: '3rem',
					flexBasis: '50%',
				}}
			>
				{/* display image */}
				<div
					className='form-field row'
					style={{
						alignItems: 'flex-start',
					}}
				>
					<span className='form-label'>Display Image</span>
					<div className='display-pic-root'>
						<div className='display-pic-preview'>
							<img
								src={fields.image}
								className={`display-pic ${
									fields.image ? 'show' : 'hide'
								}`}
								alt='product-display'
							/>
						</div>
					</div>
				</div>
				<div className='form-field row'>
					<div className='form-label'>Product Category</div>
					<div className='form-value'>{fields.categoryName}</div>
				</div>
				<div className='form-field row'>
					<div className='form-label'>Product Sub Category</div>
					<div className='form-value'>{fields.subCategoryName}</div>
				</div>
			</div>
		</div>
	);
};

GeneralDetails.defaultProps = {
	fields: {},
};

export default GeneralDetails;
